import { cx } from "../../../styled-system/css";
import { styles } from "./CategoryCard.style";
import { Icon } from "../../elements/Icon";

export interface CategoryCardProps {
  title: string;
  excerpt: string;
  icon?: string;
  className?: string;
  iconTitle?: string;
  href?: string;
  linkSeeAllArticlesLabel?: string;
}

export const CategoryCard = (props: CategoryCardProps) => {
  const { title, excerpt, icon, className, iconTitle, href, linkSeeAllArticlesLabel } = props;
  const getCategoryLabel = () =>
    href ? (
      <a href={href} data-testid="category-link" className={styles.categoryCta()}>
        {">"} {linkSeeAllArticlesLabel}
      </a>
    ) : (
      <strong className={styles.categoryCta()}>
        {">"} {linkSeeAllArticlesLabel}
      </strong>
    );

  return (
    <div data-testid="category-card" className={cx(styles.categoryCard(), className)}>
      <div className={styles.categoryIconWrapper()}>
        {icon && (
          <Icon
            icon={icon}
            desc={iconTitle}
            title={iconTitle}
            className={cx(styles.categoryIconPlaceholder(), "icon-color-override")}
          />
        )}
      </div>
      <div data-testid="category-title" className={styles.categoryTitle()}>
        {title}
      </div>
      <p className={styles.categoryExcerpt()}>{excerpt}</p>
      {getCategoryLabel()}
    </div>
  );
};
